import { NameValuePair } from 'components/Models/nameValuePair'

const ProductBuildingType: NameValuePair<string>[] = [
    { name: 'Airports and Runways', value: 'Airports and Runways' },
    { name: 'Automotive Facility', value: 'Automotive Facility' },
    { name: 'Convention Center', value: 'Convention Center' },
    { name: 'Courthouse', value: 'Courthouse' },
    { name: 'Data Center', value: 'Data Center' },
    { name: 'Dining Cafeteria Fast Food', value: 'Dining Cafeteria Fast Food' },
    {
        name: 'Dining Bar Lounge or Leisure',
        value: 'Dining Bar Lounge or Leisure',
    },
    { name: 'Dining Family', value: 'Dining Family' },
    { name: 'Dormitory', value: 'Dormitory' },
    { name: 'Exercise Center', value: 'Exercise Center' },
    { name: 'Fire Station', value: 'Fire Station' },
    { name: 'Gymnasium', value: 'Gymnasium' },
    { name: 'Hospital or Healthcare', value: 'Hospital or Healthcare' },
    { name: 'Hotel', value: 'Hotel' },
    { name: 'Laboratory', value: 'Laboratory' },
    { name: 'Library', value: 'Library' },
    { name: 'Manufacturing', value: 'Manufacturing' },
    { name: 'Mixed Use', value: 'Mixed Use' },
    { name: 'Motel', value: 'Motel' },
    { name: 'Motion Picture Theatre', value: 'Motion Picture Theatre' },
    { name: 'Multi Family', value: 'Multi Family' },
    { name: 'Museum', value: 'Museum' },
    { name: 'Office', value: 'Office' },
    { name: 'Parking Garage', value: 'Parking Garage' },
    { name: 'Penitentiary', value: 'Penitentiary' },
    { name: 'Performing Arts Theater', value: 'Performing Arts Theater' },
    { name: 'Police Station', value: 'Police Station' },
    { name: 'Post Office', value: 'Post Office' },
    { name: 'Rail and Transit Systems', value: 'Rail and Transit Systems' },
    { name: 'Religious Building', value: 'Religious Building' },
    { name: 'Retail', value: 'Retail' },
    {
        name: 'Roads, Highways, and Bridges',
        value: 'Roads, Highways, and Bridges',
    },
    { name: 'School or University', value: 'School or University' },
    { name: 'Schools (K-12)', value: 'Schools (K-12)' },
    { name: 'Single Family', value: 'Single Family' },
    { name: 'Sports Arena', value: 'Sports Arena' },
    { name: 'Town Hall', value: 'Town Hall' },
    { name: 'Transportation', value: 'Transportation' },
    { name: 'Universities', value: 'Universities' },
    {
        name: 'Utility and Pipeline Infrastructure',
        value: 'Utility and Pipeline Infrastructure',
    },
    { name: 'Warehouse', value: 'Warehouse' },
    {
        name: 'Water and Wastewater Treatment Plants',
        value: 'Water and Wastewater Treatment Plants',
    },
    { name: 'Workshop', value: 'Workshop' },
]

export default ProductBuildingType
